/**
 * Created by Ivan on 30.10.2026
 */

const Merge2MissionOfferDay = 6;

Placements.ENTRIES["merge2MissionOfferStart"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_MERGE2_MISSION);
        return Boolean(mission && !mission.logic.offerStarted
            && Date.now() >= mission.started + cleverapps.parseInterval(`${Merge2MissionOfferDay - 1} days`));
    },

    action: function () {
        cleverapps.missionManager.findRunningMission(Mission.TYPE_MERGE2_MISSION).logic.markOfferStarted();

        cleverapps.eventBus.trigger("MERGE2_MISSION_OFFER_DAY");
    }
};
